
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { FiscalUpdatePeriodCriteria, IFiscal, ILookupService, LookupCriteria } from "@tylertech/tyler-api-types";

/**
 * FiscalService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class FiscalService {
    private readonly $apiService = inject(ApiService);
    
    Get(fiscalId: string): Promise<IFiscal> {
        return this.$apiService.sendAuth("IFiscalService/Get", fiscalId);
    }
    GetControllingFiscal(): Promise<IFiscal> {
        return this.$apiService.sendAuth("IFiscalService/GetControllingFiscal");
    }
    Lookup(pCriteria: LookupCriteria): Promise<IFiscal[]> {
        return this.$apiService.sendAuth("IFiscalService/Lookup", pCriteria);
    }
    UpdateFundFiscalPeriodIsOpen(fiscalUpdatePeriodCriteria: FiscalUpdatePeriodCriteria): Promise<void> {
        return this.$apiService.sendAuth("IFiscalService/UpdateFundFiscalPeriodIsOpen", fiscalUpdatePeriodCriteria);
    }
}
